import api from './api';
import { TTIRequestLog, TTIRequestLogListResponse } from '../types';

export const ttiLogService = {
  // Get all logs for a batch import
  getBatchImportLogs: async (batchImportId: number, skip = 0, limit = 100): Promise<TTIRequestLogListResponse> => {
    const response = await api.get<TTIRequestLogListResponse>(
      `/api/batch-imports/${batchImportId}/logs?skip=${skip}&limit=${limit}`
    );
    return response.data;
  },

  // Get all logs for a specific batch import item
  getBatchImportItemLogs: async (batchImportId: number, itemId: number): Promise<TTIRequestLogListResponse> => {
    const response = await api.get<TTIRequestLogListResponse>(
      `/api/batch-imports/${batchImportId}/items/${itemId}/logs`
    );
    return response.data;
  },

  // Get detailed log by ID
  getLogDetail: async (logId: number): Promise<TTIRequestLog> => {
    const response = await api.get<TTIRequestLog>(`/api/tti-logs/${logId}`);
    return response.data;
  },

  // Get all TTI logs with optional filtering
  getAllLogs: async (
    skip = 0,
    limit = 100,
    operationType?: string,
    success?: boolean
  ): Promise<TTIRequestLogListResponse> => {
    let url = `/api/tti-logs?skip=${skip}&limit=${limit}`;
    if (operationType) url += `&operation_type=${operationType}`;
    if (success !== undefined) url += `&success=${success}`;

    const response = await api.get<TTIRequestLogListResponse>(url);
    return response.data;
  },
};

